<template>
	<div id="cashieraccount" class="public-content">
    <!-- 公共form表单样式 -->
    <div class="form-item-public">
      <el-form inline label-position="left" :model="formData">
        <el-form-item label="账户">
          <el-radio-group size="mini" v-model="formData.account" @change="getData()">
            <el-radio-button label="1" :disabled="laodingModal">现金</el-radio-button>
            <el-radio-button label="2" :disabled="laodingModal">银行存款</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="fr">
           <el-button size="small" @click="openTheModal">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 公共table 样式 -->
    <div class="table-item-public">
    	<el-table size="small" border style="width:100%" :data="tableData"
          v-loading="laodingModal" element-loading-text="查询列表数据中"
      >
    	  <el-table-column label="编码" align="center" prop="code"></el-table-column>
    	  <el-table-column label="账户名称" align="center" prop="name"></el-table-column>
    	  <el-table-column label="期初月份" align="center" prop="date"></el-table-column>
    	  <el-table-column label="期初金额" align="center" prop="moneys"></el-table-column>
    	  <el-table-column label="币别" align="center" prop="currencyName"></el-table-column>
    	  <el-table-column label="科目" align="center" prop="subjctName"></el-table-column>
    	  <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.state" @change="switchChange($event,scope.row)"
                :active-value="1"
                :inactive-value="0"
               ></el-switch>
            </template>
        </el-table-column>
    	  <el-table-column label="操作" align="center">
    	    <template slot-scope="scope">
    	       <el-button type="text" size="small" @click="editAccount(scope.row)">编辑</el-button>
    	       <el-button class="delete" type="text" size="small" @click="deleteList(scope.row)">删除</el-button>
    	    </template>
    	  </el-table-column>
    	</el-table>
    </div>
    <!-- 公共 page 样式 -->
    <!-- <div class="page-item-public">
    	<el-pagination background small
    	@size-change="pageSizeChange"  @current-change="pageIndexChange" @prev-click="pageIndexChange" @next-click="pageIndexChange"
    	layout="total, prev, pager, next, sizes, jumper" :total="page.totall" :current-page="page.pageIndex" :page-size="page.pageSize">
    	</el-pagination>
    </div> -->


    <el-dialog :visible.sync="addModal" :title="dialogTitle" width="400px" :close-on-click-modal="false" class='default-dialog'>
      <el-form inline label-position="left"
        :model="formDataAdd" label-width="80px"
        ref="addModalRef" :rules="addAccountRule"
        v-if="addModal"  v-loading="modalLoading" element-loading-text="保存账户中"
      >
        <el-form-item label="编码:" required prop="code">
          <el-input v-model="formDataAdd.code" placeholder="请输入编码" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="名称:" required prop="name">
          <el-input v-model="formDataAdd.name" placeholder="请输入名称"  size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="期初月份:" required prop="date">
          <el-date-picker
            v-model="formDataAdd.date"
            value-format="yyyy-MM"
            type="month"
            size="small"
            placeholder="选择期初月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="期初金额:" required prop="money">
          <el-input v-model="formDataAdd.money" placeholder="请输入名称"  size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="币别:" required prop="fkCurrencyId">
          <el-select v-model="formDataAdd.fkCurrencyId" placeholder="请选择币种"  size="small" filterable clearable>
            <el-option v-for="(item,index) in dictList.curreny" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目:" prop="fkSubjectId">
          <el-select v-model="formDataAdd.fkSubjectId" placeholder="请输入编码或科目名称"  size="small" filterable clearable>
            <el-option v-for="(item,index) in dictList.allSubjct" :key="index" :label="item.code +' '+item.name" :value="item.id"></el-option>
          </el-select>
          <el-button type="text" size="small" @click="openSubjectTree">科目</el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer-right" v-if="!modalLoading">
				<el-button size="small" @click="addModal = false">取消</el-button>
				<el-button size="small" class='minButton' @click="saveAccount()">确定</el-button>
			</div>
    </el-dialog>

    <!-- 新增摘要modal -->
    <el-dialog title="科目" :visible.sync="km.modal" width="430px" :close-on-click-modal="false"  class='default-dialog'>
    	<div v-loading="km.loading">
    		<el-tabs v-model="km.tabs" @tab-click="tabHandle">
    			<el-tab-pane v-for="(item,index) in dictList.typelist" :key="index" :label="item" :name="item"></el-tab-pane>
    		</el-tabs>
    		<div style="width: 100%;max-height: 500px;overflow-y: auto;">
    			<el-tree
    				:data="km.data"
    				:expand-on-click-node="false"
    				@node-click="HandleNodeClick"
    				@dblclick.native="enterKMtree"
    			></el-tree>
    		</div>
    	</div>
    	<div slot="footer" class="dialog-footer-right">
    		<el-button size="small" @click="km.modal = false">取消</el-button>
    		<el-button size="small" class='minButton' @click="enterKMtree">确定</el-button>
    	</div>
    </el-dialog>
	</div>
</template>

<script>
  import {currencys} from '@/assets/utils/currencyFormat'
  export default{
    data(){
      return {
        dialogTitle:"新增账户",
        page:{
          pageIndex:1,
          pageSize:10,
          totall:0,
        },
        tableData:[],

        formData:{
          account:1,
        },

        formDataAdd:{
          code:'',
          name:'',
          date:"",
          money:"",
          fkCurrencyId:'',
          fkSubjectId:'',
        },
        addAccountRule:{
          code:[{required:true,message:'编码必填！'}],
          name:[{required:true,message:'名称必填！'}],
          date:[{required:true,message:'日期必填！'}],
          money:[{required:true,message:'期初余额必填！'}],
          fkCurrencyId:[{required:true,message:'请选择币别！'}],
        },
        modalLoading:false,
        km:{
        	modal:false,
        	loading:false,
        	tabs:'',
        	data:[],
        	datas:{},
        },

        dictList:{
          curreny:[],
          allSubjct:[],
          typelist:[]
        },
        addModal:false,
        laodingModal:false,
      }
    },
    created(){
      this.getCurrency();
      this.getAllSubject();
      this.getData();
    },
    mounted(){

    },
    methods:{
      getData(){
        const _=this;
        _.laodingModal = true;
        _.$http.post('journal/findAccount',{type:_.formData.account}).then(res=>{
            _.laodingModal = false;
            if(res && res.data.code == '1'){
                _.tableData = res.data.data.map(i=>{
                  i.date = this.$formart(i.date,'yyyy-MM');
                  i.moneys = currencys(i.money);
                  return i;
                });
            }
        }).catch(e=>{
            _.laodingModal = false;
        });
      },
      openSubjectTree(){
          const _=this;
          _.km.modal = true;
          _.getAllSubjectType();
      },
      switchChange(val,row){//启用禁用状态修改
        const _=this;

         const prevent =  this.$getSessionStorage('superPreventOperation');
          if(prevent) {
            this.$store.commit('SUPERPREVENTFUNCTION',true);
            this.getData();
            return;
          }
        _.$http.post('/journal/prohibitEnable',{id:row.id}).then(res=>{
            _.getData();
            if(res.data.code == '1'){
              _.$message.success(res.data.msg);
            }else{
              _.$message.error(res.data.msg);
            }
        }).catch(e=>{

        });
      },
      editAccount(row){//编辑账户
        const _=this;
        _.dialogTitle = "编辑账户";
         const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        _.addModal = true;
        Object.assign(_.formDataAdd,row);
      },
      deleteList(row){//删除列
        const _=this;

        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        _.$confirm('确定删除 '+row.name+' 这条数据吗？','删除',{
            confirmButtonText:'确定删除',
            cancelButtonText:'取消',
            type:'warning'
        }).then(()=>{
            _.$http.post('journal/delete',{id:row.id}).then(res=>{
                if(res.data.code == '1'){
                  _.$message.success('删除成功!');
                  _.getData();
                }
            });
        });
      },
      openTheModal(){
        const _=this;
        _.dialogTitle = "新增账户";
        const prevent =  this.$getSessionStorage('superPreventOperation');
        if(prevent) {
          this.$store.commit('SUPERPREVENTFUNCTION',true);
          return;
        }
        _.addModal = true;
        _.getCodes();
        Object.assign(_.formDataAdd,{
          code:'',
          name:'',
          money:"",
          date:"",
          fkCurrencyId:'',
          fkSubjectId:'',
          id:'',
        });
      },
      getCodes(){//获取code
        const _=this;
        _.modalLoading = true;
        _.$http.post('/journal/getCode',{type:_.formData.account}).then(res=>{
          _.modalLoading = false;
          if(res && res.data.code == '1'){
              _.formDataAdd.code = res.data.data;
          }
        }).catch(e=>{
          _.modalLoading = false;
        });
      },
      saveAccount(){//保存账户
        const _=this;
        _.$refs.addModalRef.validate((valid)=>{
          if(valid){
            let datas = JSON.parse(JSON.stringify(_.formDataAdd));
            datas.type = _.formData.account;
            _.modalLoading = true;
            _.$http.post('/journal/saveAccount',datas).then(res=>{
                _.modalLoading = false;
                if(res && res.data.code == '1'){
                  _.addModal = false;
                  _.$message.success(res.data.msg);
                  _.getData();
                }
            }).catch(e=>{
                _.modalLoading = false;
            });
          }
        });
      },
      tabHandle(val){
      	this.km.tabs = val.name;
      	this.getTreeSubject();
      },
      HandleNodeClick(data){
          this.km.datas = data;
      },
      enterKMtree(){
          const _=this;
          if(_.km.datas.children.length > 0){
            _.$message.error('不能选择父级科目！');
          }else{
            _.km.modal = false;
            _.formDataAdd.fkSubjectId = _.km.datas.id;
          }
      },

      getCurrency(){//查询币种
         const _=this;
         _.$http.post('foreignCurrency/findAll',{}).then((res)=>{
            if(res.data.code=='1' && res){
              _.dictList.curreny = res.data.data;
            }
         });
      },
      getAllSubject(){//查询科目
        const _=this;
        _.$http.post('subject/getAllSujectByContent',{}).then((res)=>{
          if(res && res.data.code == '1'){
              _.dictList.allSubjct = res.data.data;
          }
        })
      },
      getAllSubjectType(){//获取科目类别
      	const _=this;
      	_.km.loading = true;
      	_.$http.post('subject/getSubjectType',{}).then((res)=>{
      		_.km.loading = false;
      		if(res && res.data.code == '1'){
      			_.dictList.typelist = res.data.data;
      			_.km.tabs = res.data.data[0];
      			_.getTreeSubject();
      		}
      	}).catch(()=>{
      		_.km.loading = false;
      	})
      },
      getTreeSubject(){ //获取科目树
      	const _=this;
      	_.km.loading = true;
      	_.$http.post('subject/ajaxgetTree',{
      		type:_.km.tabs,
      	}).then((res)=>{
      		_.km.loading = false;
      		if(res && res.data.code == '1'){
      			var datas = res.data.data;
            let list = _.getTreeData(datas);
      			_.km.data = list;
      		}
      	}).catch(()=>{
      		_.km.loading = false;
      	});
      },
      getTreeData(list){
      	for(let i=0;i<list.length;i++){
      		list[i].label = list[i].code+' '+list[i].name;
      		if(list[i].children && list[i].children.length >0){
      			this.getTreeData(list[i].children);
      		}
      	}
      	return list;
      },
      //页码发送变化
      pageIndexChange(page){
      	this.page.pageIndex = page;
      	this.getData();
      },//页码条数发送变化
      pageSizeChange(page){
      	this.page.pageSize = page;
      	this.getData();
      },
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/cashier/cashieraccount.vue